import { createContext } from 'react'
import { ddlListItem } from '../components/dropDownList/DropDownList'
import { IFormDataInput } from '../model/IFormDataInput'
import { ParentDataObject } from './contextDataObjects/ParentDataObject'
export interface IParentFormData {
    [key: string]: any
    ReturnHome: string
    Language: number
    Province: ddlListItem
    FirstName: string
    LastName: string
    Address: string
    City: string
    PostalCode: string
    PhoneNumber: string
    Email: string
    ExternalRef?: string
    DoNotOffer: boolean
    OrgGuid: string,
    RegionId: number,
    ParentFormDataInput: IFormDataInput[]
    TotalPremium: number
    FamilyRate: boolean
    StartDate: any
    QuoteErrorMessages: string[]
    SchoolBoard: ddlListItem
    PlanDuration: {
        DurationText: string
        Duration: number
        Discount: string
        Index: number
    }
    AutoEnroll: {
        Renew: string
        Index: number
        IsValid: boolean
    }
    CommonChildPlanFormInputData: {
        Id: string
        Name: string
        Type: string
        ControlType: string
        ListItems: ddlListItem[]
        Placeholder: string
        Label: string
        Required: boolean
        ClassName: string
        Width: string
        Height: string
        Shadow: string
        ErrorMessageList: { type: string; error: string }[]
        ErrorMessage: string
        Pattern: string
        IsValid: boolean
        IsBlur: boolean
        IsFocus: boolean
        Disabled: boolean
    }
    CommonChildPlanStartDate: {
        Id: string
        Name: string
        ControlType: string
        Placeholder: string
        Label: string
        Required: boolean
        ClassName: string
        Width: string
        Height: string
        Shadow: string
        ErrorMessageList: { type: string; error: string }[]
        ErrorMessage: string
        Pattern: any
        IsValid: boolean
        IsBlur: boolean
        IsFocus: boolean
    }
    SchoolListItems: ddlListItem[]
}

interface IParentFormDataContextValue {
    parentFormData: IParentFormData
    setParentFormData: React.Dispatch<React.SetStateAction<IParentFormData>>
}

const parentFormDataContext = createContext<IParentFormDataContextValue>({
    parentFormData: ParentDataObject,
    setParentFormData: () => { },
})

export default parentFormDataContext
